import { apiFetch } from "./client";

const buildQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    search.set(key, value);
  });
  const qs = search.toString();
  return qs ? `?${qs}` : "";
};

const fetchReportSummary = (params = {}) => apiFetch(`/api/reports/summary${buildQuery(params)}`);
const fetchReportTrends = (params = {}) => apiFetch(`/api/reports/trends${buildQuery(params)}`);
const fetchReportRisks = (params = {}) => apiFetch(`/api/reports/risks${buildQuery(params)}`);
const fetchReportConcentration = (params = {}) => apiFetch(`/api/reports/concentration${buildQuery(params)}`);
const fetchReportWatchlists = (params = {}) => apiFetch(`/api/reports/watchlists${buildQuery(params)}`);

export {
  fetchReportSummary,
  fetchReportTrends,
  fetchReportRisks,
  fetchReportConcentration,
  fetchReportWatchlists,
};
